<template>
  <div>
    <!-- Sidebar existente -->
    <div class="sidebar" :class="{ 'sidebar-cerrado': cerrado, 'oculto': isMobile }">
      <nav class="menu">
        <li class="toggle" @click="toggleSidebar">
          <!-- Sidebar cerrado: solo hamburguesa -->
          <span v-if="cerrado" class="material-icons">menu</span>

          <!-- Sidebar abierto: logo visible, X aparece al hacer hover -->
          <div v-else class="toggle-open">
            <img src="@/assets/imagenes/logotipo_beige.png" alt="Domédica" class="sidebar-logo" />
            <span class="material-icons toggle-close-icon">close</span>
          </div>
        </li>
        <li class="usuario">
          <span class="material-icons">person</span>
          <span v-if="!cerrado">{{ nombreUsuario }}</span>
        </li>

        <li v-if="rango !== 'hotel'" @click="redirigir('/dashboard')">
          <span class="material-icons">dashboard</span>
          <span v-if="!cerrado">Dashboard</span>
        </li>

        <li v-if="rango !== 'hotel'" @click="redirigir('/registro')">
          <span class="material-icons">assignment</span>
          <span v-if="!cerrado">Registro de consulta</span>
        </li>

        <li v-if="puedeAgregarDoctor" @click="redirigir('/admin')">
          <span class="material-icons">group</span>
          <span v-if="!cerrado">Doctores</span>
        </li>

        <!-- Cambio: Hoteles → Aliados, ícono hotel → business -->
        <li v-if="esAdministrador" @click="redirigir('/hoteles')">
          <span class="material-icons">business</span>
          <span v-if="!cerrado">Aliados</span>
        </li>

        <li v-if="esAdministrador" @click="redirigir('/dashboard-admin')">
          <span class="material-icons">insights</span>
          <span v-if="!cerrado">Analítica</span>
        </li>

        <!-- Cambio: Panel Hotel → Panel Aliados -->
        <li v-if="puedeAgregarDoctor || rango === 'hotel'" @click="redirigir('/panel-hotel')">
          <span class="material-icons">bar_chart</span>
          <span v-if="!cerrado">Panel Aliados</span>
        </li>

        <li @click="logout">
          <span class="material-icons">logout</span>
          <span v-if="!cerrado">Logout</span>
        </li>
      </nav>
      <div v-if="mostrarPanelDoctores && !cerrado" class="panel-doctores" :class="{ 'panel-doctores-visible': mostrarPanelDoctores }">
        <div class="panel-doctores-header">
          <h3>Doctores</h3>
          <button class="btn-cerrar-panel" @click="mostrarPanelDoctores = false">×</button>
        </div>

        <div class="panel-doctores-actions">
          <button class="btn-registrar-doctor" @click="abrirModalRegistro">Registrar doctor</button>
        </div>

        <div v-if="cargandoDoctores" class="panel-doctores-vacio">Cargando doctores…</div>
        <div v-else-if="!doctores.length" class="panel-doctores-vacio">No hay doctores registrados.</div>
        <div v-else class="tabla-doctores-wrap">
          <table class="tabla-doctores">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Usuario</th>
                <th>Cédula</th>
                <th>Teléfono</th>
                <th>Correo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(doctor, index) in doctores" :key="index">
                <td>{{ doctor.nombre_completo || '-' }}</td>
                <td>{{ doctor.usuario || '-' }}</td>
                <td>{{ doctor.cedula || '-' }}</td>
                <td>{{ doctor.telefono || '-' }}</td>
                <td>{{ doctor.correo || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>

    <transition name="modal">
      <div v-if="mostrarModalRegistro" class="modal-backdrop" @click.self="cerrarModalRegistro">
        <div class="modal-registro">
        <div class="modal-header">
          <h3>Registrar doctor</h3>
          <button class="btn-cerrar-panel" @click="cerrarModalRegistro"><span class="material-icons">close</span></button>
        </div>

        <form @submit.prevent="registrarDoctor" class="form-registro-doctor">
          <div class="modal-body-scroll">
            <div class="campo-grid">
              <div class="campo">
                <label>Nombre</label>
                <input v-model="doctorForm.nombre" class="form-control" required />
              </div>
              <div class="campo">
                <label>Apellido paterno</label>
                <input v-model="doctorForm.apellido_paterno" class="form-control" required />
              </div>
            </div>
            <div class="campo-grid">
              <div class="campo">
                <label>Apellido materno</label>
                <input v-model="doctorForm.apellido_materno" class="form-control" />
              </div>
              <div class="campo">
                <label>Cédula</label>
                <input v-model="doctorForm.cedula" class="form-control" />
              </div>
            </div>
            <div class="campo-grid">
              <div class="campo">
                <label>Contraseña</label>
                <input v-model="doctorForm.contraseña" type="password" class="form-control" required />
              </div>
              <div class="campo">
                <label>Teléfono</label>
                <input v-model="doctorForm.telefono" class="form-control" required />
              </div>
            </div>
            <div class="campo-grid">
              <div class="campo">
                <label>Correo</label>
                <input v-model="doctorForm.correo" type="email" class="form-control" required />
              </div>
              <div class="campo">
                <label>Rango</label>
                <select v-model="doctorForm.rango" class="form-select" required>
                  <option value="doctor">Doctor</option>
                  <option value="jefe">Jefe</option>
                  <option value="administrador">Administrador</option>
                </select>
              </div>
            </div>
          </div>

          <div class="modal-footer-sticky">
            <button type="submit" class="btn-guardar-doctor" :disabled="cargandoDoctor">
              {{ cargandoDoctor ? 'Registrando...' : 'Registrar doctor' }}
            </button>
          </div>
        </form>
      </div>
    </div>
    </transition>

    <!-- Navbar para móviles -->
    <div class="navbar" v-if="isMobile">
      <button class="btn-menu" @click="toggleMenu">
        <span class="material-icons">menu</span>
      </button>

      <transition name="slide-down">
        <div class="menu-movil" v-if="menuAbierto">
          <li v-if="rango !== 'hotel'" @click="redirigir('/dashboard')">
          <span class="material-icons">dashboard</span> Dashboard
        </li>
        <li v-if="rango !== 'hotel'" @click="redirigir('/registro')">
          <span class="material-icons">assignment</span> Registro de consulta
        </li>
        <li v-if="puedeAgregarDoctor" @click="redirigir('/admin')">
          <span class="material-icons">group</span> Doctores
        </li>
        <li v-if="esAdministrador" @click="redirigir('/hoteles')">
          <span class="material-icons">business</span> Aliados
        </li>
        <li v-if="esAdministrador" @click="redirigir('/dashboard-admin')">
          <span class="material-icons">insights</span> Analítica
        </li>
        <li v-if="puedeAgregarDoctor || rango === 'hotel'" @click="redirigir('/panel-hotel')">
          <span class="material-icons">bar_chart</span> Panel Aliados
        </li>
        <li @click="logout">
          <span class="material-icons">logout</span> Logout
        </li>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { getUsuarios, getMe, addUsuario } from '@/utils/api';

export default {
  data() {
    return {
      cerrado: false,
      isMobile: window.innerWidth <= 768,
      nombreUsuario: 'Cargando...',
      rango: '',
      menuAbierto: false,
      mostrarPanelDoctores: false,
      mostrarModalRegistro: false,
      cargandoDoctor: false,
      cargandoDoctores: false,
      doctores: [],
      doctorForm: {
        nombre: '',
        apellido_paterno: '',
        apellido_materno: '',
        cedula: '',
        contraseña: '',
        telefono: '',
        correo: '',
        rango: 'doctor',
      },
    };
  },
  computed: {
    puedeAgregarDoctor() {
      return ['jefe', 'administrador'].includes((this.rango || '').toLowerCase());
    },
    esAdministrador() {
      return (this.rango || '').toLowerCase() === 'administrador';
    },
  },
  methods: {
    toggleSidebar() {
      this.cerrado = !this.cerrado;
      this.$emit("cambiar-estado", this.cerrado);
    },
    toggleMenu() {
      this.menuAbierto = !this.menuAbierto;
    },
    abrirAdministracionUsuarios() {
      this.$router.push('/administrador-usuarios');
      this.menuAbierto = false;
      this.mostrarPanelDoctores = false;
      this.mostrarModalRegistro = false;
    },
    abrirModalRegistro() {
      this.mostrarModalRegistro = true;
    },
    cerrarModalRegistro() {
      this.mostrarModalRegistro = false;
    },
    async cargarDoctores() {
      this.cargandoDoctores = true;
      this.doctores = await getUsuarios();
      this.cargandoDoctores = false;
    },
    async registrarDoctor() {
      if (this.cargandoDoctor) return;

      const camposObligatorios = ['nombre', 'apellido_paterno', 'contraseña', 'telefono', 'correo', 'rango'];
      const hayCamposVacios = camposObligatorios.some((campo) => !String(this.doctorForm[campo]).trim());

      if (hayCamposVacios) {
        Swal.fire({
          icon: 'warning',
          title: 'Completa el formulario',
          text: 'Todos los campos son obligatorios para registrar al doctor.',
          confirmButtonColor: '#133e68',
        });
        return;
      }

      this.cargandoDoctor = true;

      try {
        await addUsuario({ ...this.doctorForm });

        this.cerrarModalRegistro();
        this.cargarDoctores();

        Swal.fire({
          icon: 'success',
          title: 'Doctor registrado',
          text: 'El doctor se registró correctamente.',
          confirmButtonColor: '#133e68',
        });

        this.doctorForm = {
          nombre: '',
          apellido_paterno: '',
          apellido_materno: '',
          cedula: '',
          contraseña: '',
          telefono: '',
          correo: '',
          rango: 'doctor',
        };
        this.cerrarModalRegistro();
        this.cargarDoctores();
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error al registrar',
          text: error.message || 'Ocurrió un problema al enviar el formulario.',
          confirmButtonColor: '#d33',
        });
      } finally {
        this.cargandoDoctor = false;
      }
    },
    redirigir(ruta) {
      this.$router.push(ruta);
      this.menuAbierto = false;
      this.mostrarPanelDoctores = false;
      this.mostrarModalRegistro = false;
    },
    logout() {
      ['id_doctor', 'hotel_id', 'hotel_nombre', 'tipo_sesion', 'rango', 'token'].forEach(k => localStorage.removeItem(k));
      this.$router.push('/');
    },
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768;
      this.$emit("cambiar-estado", this.isMobile ? true : this.cerrado);
    },
    async obtenerDatosUsuario() {
      const tipo = localStorage.getItem('tipo_sesion');
      if (tipo === 'hotel') {
        this.nombreUsuario = localStorage.getItem('hotel_nombre') || 'Hotel';
        this.rango = 'hotel';
        return;
      }
      if (!localStorage.getItem('id_doctor')) { this.nombreUsuario = 'Usuario desconocido'; return; }
      try {
        const { usuario } = await getMe();
        this.nombreUsuario = `${usuario.nombre} ${usuario.apellido_paterno}`;
        this.rango = usuario.rango;
      } catch {
        this.nombreUsuario = 'Usuario desconocido';
      }
    }
  },
  mounted() {
    this.obtenerDatosUsuario();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  }
};
</script>
  
<style scoped>
/* ============================================================
   DOMÉDICA - ESTILOS PARA REGISTRO DE PACIENTES Y SIDEBAR
   Basado en el Manual de Identidad (PDF)
   ============================================================ */

/* ---------- CONTENEDOR PRINCIPAL DEL REGISTRO ---------- */
.registro-contenedor {
  display: flex;
  min-height: 100vh;
  background-color: var(--brand-beige);   /* #F4EFEB - Fondo de página */
}

/* ---------- CONTENIDO DEL FORMULARIO ---------- */
.contenido {
  flex-grow: 1;
  margin: 40px auto;
  padding: 30px 40px;
  max-width: 850px;
  background: var(--white);               /* #FFFFFF */
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(19, 62, 104, 0.12);
  transition: margin-left 0.3s ease, box-shadow 0.3s ease;
}

.contenido:hover {
  box-shadow: 0 10px 30px rgba(19, 62, 104, 0.18);
}

.contenido-expandido {
  margin-left: 30%;
}

/* ---------- TÍTULOS DE SECCIÓN ---------- */
.seccion-titulo {
  font-size: 20px;
  font-weight: 700;
  color: var(--brand-primary);            /* #133E68 */
  margin: 20px 0 10px;
  border-bottom: 3px solid var(--brand-primary);
  padding-bottom: 8px;
  letter-spacing: -0.3px;
}

/* ---------- ETIQUETAS Y CAMPOS ---------- */
.form-label {
  font-weight: 600;
  color: var(--brand-secondary);
  margin-bottom: 4px;
}

.form-control,
.form-select,
.textarea-grande {
  border: 2px solid var(--brand-secondary-light);
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 15px;
  color: var(--brand-secondary);
  background-color: var(--white);
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  width: 100%;
  box-sizing: border-box;
}

.form-control:focus,
.form-select:focus,
.textarea-grande:focus {
  outline: none;
  border-color: var(--brand-accent-sage);
  box-shadow: 0 0 0 4px rgba(96, 127, 112, 0.2);
}

.form-control::placeholder,
.form-select::placeholder,
.textarea-grande::placeholder {
  color: var(--brand-secondary-light);
  font-weight: 400;
}

.textarea-grande {
  resize: none;
  height: 100px;
}

/* ---------- BOTONES ---------- */
button,
.btn-registrar,
.btn-guardar {
  background-color: var(--brand-accent-sage);
  color: var(--white);
  border: none;
  padding: 12px 28px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(96, 127, 112, 0.25);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

button:hover,
.btn-registrar:hover,
.btn-guardar:hover {
  background-color: var(--brand-accent-navy);
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(48, 80, 101, 0.35);
}

button:active,
.btn-registrar:active,
.btn-guardar:active {
  transform: scale(0.96);
}

.btn-secondary {
  background-color: var(--brand-secondary-light);
  box-shadow: none;
}

.btn-secondary:hover {
  background-color: var(--brand-secondary);
}

/* ---------- SIDEBAR (60% Dominante - Azul Profundo) ---------- */
.sidebar {
  width: 250px;
  height: 100vh;
  background: var(--brand-primary);
  position: fixed;
  color: var(--white);
  font-weight: 700;
  font-size: large;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
  transition: width 0.3s ease;
  z-index: 1000;
  box-shadow: 2px 0 15px rgba(19, 62, 104, 0.15);
  overflow: hidden; /* ← Evita que la imagen se desborde */
}

.sidebar-cerrado {
  width: 80px;
}

/* Elementos ocultos */
.oculto {
  display: none;
}

/* ---------- MENÚ DE NAVEGACIÓN ---------- */
.menu {
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
}

.menu li {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  padding: 14px 20px;
  transition: background 0.2s ease;
  list-style: none;
  color: var(--white);
}

.menu li:not(.usuario) {
  cursor: pointer;
}

.menu li:not(.usuario):hover {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 8px;
}

.toggle {
  cursor: pointer;
  justify-content: flex-start;
  margin-bottom: 10%;
  color: var(--white);
  background: none;
  border: none;
  padding: 10px 20px;
  transition: background 0.2s ease;
}

.toggle:hover {
  background: rgba(255, 255, 255, 0.08);
  border-radius: 8px;
}

/* Contenedor cuando el sidebar está abierto */
.toggle-open {
  position: relative;
  display: flex;
  align-items: center;
  height: 30px;
  width: 100%;
}

/* Logo: visible por defecto */
.sidebar-logo {
  height: 100px;
  width: auto;
  object-fit: contain;
  opacity: 1;
  transition: opacity 0.25s ease;
  display: block;
}

/* X: invisible por defecto, posicionada encima del logo */
.toggle-close-icon {
  position: absolute;
  left: 0;
  font-size: 24px;
  opacity: 0;
  transition: opacity 0.25s ease;
}

/* Hover: logo desaparece, X aparece */
.toggle:hover .sidebar-logo     { opacity: 0; }
.toggle:hover .toggle-close-icon { opacity: 1; }

/* Sidebar cerrado: hamburguesa centrada */
.sidebar-cerrado .toggle {
  justify-content: center;
  padding: 10px;
}

.usuario {
  font-weight: 700;
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding: 15px 20px;
  color: var(--white);
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  margin-top: auto;
}

.menu li .material-icons {
  font-size: 24px;
  min-width: 30px;
}

.menu li span:nth-child(2) {
  font-size: 15px;
  transition: opacity 0.2s ease, width 0.2s ease;
  overflow: hidden;
  white-space: nowrap;
}

.sidebar-cerrado .menu li {
  justify-content: center;
}

.sidebar-cerrado .menu li span:nth-child(2) {
  opacity: 0;
  width: 0;
  margin: 0;
  padding: 0;
}

.usuario span:nth-child(2) {
  transition: opacity 0.2s ease, width 0.2s ease;
  overflow: hidden;
  white-space: nowrap;
}

.sidebar-cerrado .usuario span:nth-child(2) {
  opacity: 0;
  width: 0;
  margin: 0;
  padding: 0;
}

.panel-doctores {
  position: absolute;
  left: 100%;
  top: 0;
  width: min(420px, 78vw);
  height: 100vh;
  background: #f8fbff;
  color: var(--brand-primary);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.18);
  padding: 18px 16px 24px;
  box-sizing: border-box;
  z-index: 1300;
  overflow-y: auto;
  display: block;
  opacity: 1;
  visibility: visible;
}

.panel-doctores-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.panel-doctores-header h3 {
  margin: 0;
  font-size: 18px;
}

.btn-cerrar-panel {
  background: transparent;
  border: none;
  color: var(--brand-primary);
  font-size: 24px;
  cursor: pointer;
  padding: 0;
}

.panel-doctores-actions {
  margin-bottom: 12px;
}

.btn-registrar-doctor,
.btn-guardar-doctor {
  width: 100%;
  margin-top: 4px;
  background: var(--brand-accent-sage);
  color: var(--white);
  border: none;
  border-radius: 8px;
  padding: 10px 12px;
  font-weight: 700;
  cursor: pointer;
}

.btn-registrar-doctor:hover,
.btn-guardar-doctor:hover {
  background: var(--brand-accent-navy);
}

.btn-guardar-doctor:disabled {
  opacity: 0.7;
  cursor: wait;
}

.panel-doctores-vacio {
  padding: 14px;
  background: #edf4fb;
  border-radius: 8px;
  color: var(--brand-secondary);
}

.tabla-doctores-wrap {
  overflow-x: auto;
}

.tabla-doctores {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.tabla-doctores th,
.tabla-doctores td {
  padding: 10px 8px;
  border-bottom: 1px solid #e5edf6;
  text-align: left;
  vertical-align: top;
}

.tabla-doctores th {
  color: var(--brand-primary);
  font-weight: 700;
}

.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
  padding: 16px;
}

.modal-registro {
  width: min(600px, 95vw);
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  max-height: 86vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
}

.modal-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e8edf2;
  margin-bottom: 0;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: var(--brand-primary);
}

.btn-cerrar-panel {
  border: none;
  background: transparent;
  cursor: pointer;
  color: #666;
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: 4px;
  transition: background 0.2s;
}

.btn-cerrar-panel:hover {
  background: #f0f4f8;
}

.btn-cerrar-panel .material-icons {
  font-size: 22px;
}

.form-registro-doctor {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  gap: 0;
}

.modal-body-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overscroll-behavior: contain;
}

.modal-body-scroll::-webkit-scrollbar {
  width: 7px;
}

.modal-body-scroll::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.modal-body-scroll::-webkit-scrollbar-thumb {
  background: #9ab4a7;
  border-radius: 4px;
}

.modal-body-scroll::-webkit-scrollbar-thumb:hover {
  background: var(--brand-primary, #133e68);
}

.modal-footer-sticky {
  flex-shrink: 0;
  padding: 14px 20px;
  background: #ffffff;
  border-top: 1px solid #e8edf2;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.04);
}

.campo-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.campo {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.campo label {
  font-size: 12px;
  font-weight: 600;
  color: var(--brand-secondary);
}

.form-control,
.form-select {
  width: 100%;
  border-radius: 8px;
  border: 1px solid #d6e0eb;
  padding: 8px 10px;
  font-size: 13px;
  background: #ffffff;
  color: var(--brand-primary);
  box-sizing: border-box;
}

/* ---------- NAVBAR MÓVIL ---------- */
.navbar {
  width: 100%;
  background: var(--brand-primary);
  color: var(--white);
  padding: 12px 16px;
  display: none;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  box-shadow: 0 2px 10px rgba(19, 62, 104, 0.2);
}

.btn-menu {
  background: none;
  border: none;
  color: var(--white);
  font-size: 28px;
  cursor: pointer;
  padding: 8px;
  transition: transform 0.2s ease;
}

.btn-menu:hover {
  transform: scale(1.1);
}

/* ---------- MENÚ DESPLEGABLE MÓVIL ---------- */
.menu-movil {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: var(--white);
  color: var(--brand-primary);
  display: flex;
  flex-direction: column;
  text-align: center;
  font-weight: 700;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  border-radius: 0 0 12px 12px;
  overflow: hidden;
}

.menu-movil li {
  padding: 16px;
  border-bottom: 1px solid var(--brand-secondary-light);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: var(--brand-secondary);
  transition: background 0.2s ease;
}

.menu-movil li:hover {
  background: var(--brand-beige);
}

.menu-movil li:last-child {
  border-bottom: none;
}

.menu-movil .material-icons {
  color: var(--brand-primary);
}

/* ============================================================
   RESPONSIVE
   ============================================================ */

@media (max-width: 1024px) {
  .sidebar {
    width: 80px;
  }

  .sidebar .menu li span:nth-child(2) {
    display: none;
  }

  .sidebar .usuario span:nth-child(2) {
    display: none;
  }

  .sidebar .imagen-lateral {
    display: none;
  }

  .contenido {
    margin: 30px 20px 30px 100px;
    padding: 25px;
    max-width: 90%;
  }

  .contenido-expandido {
    margin-left: 20px;
  }
}

@media (max-width: 768px) {
  .sidebar {
    display: none;
  }

  .campo-grid {
    grid-template-columns: 1fr;
  }

  .navbar {
    display: flex;
  }

  .registro-contenedor {
    flex-direction: column;
  }

  .contenido {
    margin: 70px 10px 20px 10px;
    padding: 20px;
    max-width: 100%;
    border-radius: 10px;
  }

  .contenido-expandido {
    margin-left: 10px;
  }

  .seccion-titulo {
    font-size: 18px;
    text-align: center;
    margin-top: 10px;
  }

  .row {
    flex-direction: column;
  }

  .col-md-6 {
    width: 100%;
    margin-bottom: 10px;
  }

  button,
  .btn-registrar,
  .btn-guardar {
    width: 100%;
    justify-content: center;
    padding: 14px;
  }
}

@media (max-width: 480px) {
  .contenido {
    padding: 15px;
    margin: 65px 5px 15px 5px;
  }

  .seccion-titulo {
    font-size: 16px;
  }

  .form-control,
  .form-select,
  .textarea-grande {
    font-size: 14px;
    padding: 8px 12px;
  }

  button,
  .btn-registrar,
  .btn-guardar {
    font-size: 14px;
    padding: 12px;
  }

  .menu-movil li {
    padding: 14px;
    font-size: 15px;
  }
}

/* ============================================================
   IMPRESIÓN
   ============================================================ */
@media print {
  .sidebar,
  .navbar,
  .btn-menu,
  .menu-movil {
    display: none !important;
  }

  .registro-contenedor {
    display: block;
    background: white;
  }

  .contenido {
    margin: 0 !important;
    padding: 20px;
    max-width: 100%;
    box-shadow: none !important;
    border-radius: 0;
  }

  .seccion-titulo {
    color: #133E68 !important;
    border-bottom-color: #133E68 !important;
  }
}
</style>
  